import React from "react";

import {
  FaPlus,
  FaTimes,
} from "react-icons/fa";

import AddComandaForm from "./AddComandaForm";

const AddComanda = ({
  show,
  setShow,
}) => {
  const handleShow = () => {
    setShow(!show);
  };

  return (
    <>
      <div className="cmd-add-button-row">
        <button
          type="button"
          className={
            show
              ? "cmd-add-button cmd-add-button-cancel"
              : "cmd-add-button"
          }
          onClick={handleShow}
        >
          {show ? (
            <>
              <FaTimes />
              Cancelar
            </>
          ) : (
            <>
              <FaPlus />
              Nuevo viaje
            </>
          )}
        </button>
      </div>

      {show && (
        <div className="cmd-add-form">
          <AddComandaForm
            setShow={setShow}
          />
        </div>
      )}
    </>
  );
};

export default AddComanda;